import { combineReducers } from '@reduxjs/toolkit'
import * as localForage from "localforage";
import { persistReducer } from 'redux-persist';

import App from './apps';
import authCredentials from './authCredentials';

const rootPersistConfig = {
  key: 'AItrackingRoot',
  storage: localForage,
}

const authPersistConfig = {
  key: 'authCredentials',
  storage: localForage,
};

const rootReducer = combineReducers({
  AuthCredentials: persistReducer(authPersistConfig, authCredentials),
  App,
});

export default persistReducer(rootPersistConfig, rootReducer)
